import angular from 'angular';

(function () {
    'use strict';
    var core = angular.module('app.invitedentity');

    core.constant(
        'KISS_INVITED_ENTITY',
        Object.freeze({
            invited_entity: {
                status: [
                    { value: 'CREATED', label: 'kiss_invited_entity.status.created' },
                    { value: 'NOTIFIED', label: 'kiss_invited_entity.status.notified' },
                    { value: 'ACTIVE', label: 'kiss_invited_entity.status.active' },
                    { value: 'INACTIVE', label: 'kiss_invited_entity.status.inactive' },
                    { value: 'DUPLICATE', label: 'kiss_invited_entity.status.duplicate' },
                ],
                type: [
                    { value: null, label: 'kiss_invited_entity.type.all' },
                    { value: 'BUYER', label: 'kiss_invited_entity.type.buyer' },
                    { value: 'SELLER', label: 'kiss_invited_entity.type.seller' },
                    { value: 'INVITED', label: 'kiss_invited_entity.type.invited' },
                ],
                pagination: {
                    defaultPageSize: 20,
                    defaultSort: [
                        {
                            direction: 'ASC',
                            property: 'name',
                        },
                    ],
                    defaultPage: 0,
                },
                columnFieldMap: [
                    {
                        field: 'legalEntity.name',
                        property: 'name',
                    },
                    {
                        field: 'legalEntity.getIdentifiant()',
                        property: 'id',
                    },
                    {
                        field: 'getEntityTypeLabel()',
                        property: 'entityType',
                    },
                    {
                        field: 'getCountryLabel()',
                        property: 'country',
                    },
                    {
                        field: 'getLangLabel()',
                        property: 'lang',
                    },
                    {
                        field: 'invoiceSenderEmail',
                        property: 'senderemail',
                    },
                    {
                        field: 'getStatusLabel()',
                        property: 'status',
                    },
                    {
                        field: 'getLegalId()',
                        property: 'id',
                    },
                ],
            },
            relation: {
                pagination: {
                    defaultPageSize: 20,
                    defaultSort: [
                        {
                            direction: 'ASC',
                            property: 'principalName',
                        },
                    ],
                    defaultPage: 0,
                },
                columnFieldMap: [
                    {
                        field: 'principalName',
                        property: 'principalName',
                    },
                    {
                        field: 'buyer.getCountryLabel()',
                        property: 'buyerCountry',
                    },
                    {
                        field: 'buyer.getIdentifiant()',
                        property: 'buyerIdent',
                    },
                    {
                        field: 'buyer.name',
                        property: 'buyerName',
                    },
                    {
                        field: 'getLadType()',
                        property: 'ladType',
                    },
                    {
                        field: 'getDematMode()',
                        property: 'dematMode',
                    },
                    {
                        field: 'acceptation',
                        property: 'ackDate',
                    },
                    {
                        field: 'endOfValidity',
                        property: 'eov',
                    },
                ],
            },
            linkRequest: {
                linkRequestStatus:[
                    { value: 'PENDING', label: 'link_request.status.pending' },
                    { value: 'VALIDATED', label: 'link_request.status.validated' },
                    { value: 'REFUSED', label: 'link_request.status.refused' },
                    { value: 'CANCELED', label: 'link_request.status.canceled' }

                ],
            }
        })
    );
})();
